import useQueryAfterWorkspaceLoaded from '@webclient/hooks/useQueryAfterWorkspaceLoaded';

export default function useGetFileContentLazily({
  url,
}: {
  url: string | null;
}) {
  const {
    data: fileContent,
    isLoading: isFileContentLoading,
    isError: isFileContentError,
    refetch: refetchFileContent,
  } = useQueryAfterWorkspaceLoaded({
    queryKey: ['url', url],
    queryFn: async () => {
      try {
        if (url == null) return null;
        const response = await fetch(url);
        const text = await response.text();
        return text;
      } catch (error: unknown) {
        throw new Error(`An error occurred while fetching sources: ${error}`);
      }
    },
    options: {
      enabled: !!url,
      retry: false,
    },
  });

  return {
    fileContent,
    isFileContentLoading,
    isFileContentError,
    refetchFileContent,
  };
}
